export const SEMANTIC_COLOR = {
  NEUTRAL: 'slate',
  INFO: 'iris',
  SUCCESS: 'teal',
  WARNING: 'amber',
  DANGER: 'ruby',
};

export const SEMANTIC_COLOR_OPTIONS = Object.values(SEMANTIC_COLOR);

export const isSemanticColor = value => SEMANTIC_COLOR_OPTIONS.includes(value);

export const SEMANTIC_TEXT_CLASSES = {
  [SEMANTIC_COLOR.NEUTRAL]: 'text-n-slate-11',
  [SEMANTIC_COLOR.INFO]: 'text-n-iris-11',
  [SEMANTIC_COLOR.SUCCESS]: 'text-n-teal-12',
  [SEMANTIC_COLOR.WARNING]: 'text-n-amber-12',
  [SEMANTIC_COLOR.DANGER]: 'text-n-ruby-11',
};

export const SEMANTIC_SURFACE_CLASSES = {
  [SEMANTIC_COLOR.NEUTRAL]:
    'bg-n-slate-3 border-n-slate-4 text-n-slate-12 [&_.link]:text-n-slate-12',
  [SEMANTIC_COLOR.INFO]:
    'bg-n-iris-3 border-n-iris-4 text-n-iris-12 [&_.link]:text-n-iris-12',
  [SEMANTIC_COLOR.SUCCESS]:
    'bg-n-teal-3 border-n-teal-4 text-n-teal-12 [&_.link]:text-n-teal-12',
  [SEMANTIC_COLOR.WARNING]:
    'bg-n-amber-3 border-n-amber-4 text-n-amber-12 [&_.link]:text-n-amber-12',
  [SEMANTIC_COLOR.DANGER]:
    'bg-n-ruby-3 border-n-ruby-4 text-n-ruby-12 [&_.link]:text-n-ruby-12',
};

export const SEMANTIC_ACTION_CLASSES = {
  [SEMANTIC_COLOR.NEUTRAL]: 'bg-n-slate-4 hover:bg-n-slate-5 text-n-slate-12',
  [SEMANTIC_COLOR.INFO]: 'bg-n-iris-4 hover:bg-n-iris-5 text-n-iris-12',
  [SEMANTIC_COLOR.SUCCESS]: 'bg-n-teal-4 hover:bg-n-teal-5 text-n-teal-12',
  [SEMANTIC_COLOR.WARNING]: 'bg-n-amber-4 hover:bg-n-amber-5 text-n-amber-12',
  [SEMANTIC_COLOR.DANGER]: 'bg-n-ruby-4 hover:bg-n-ruby-5 text-n-ruby-12',
};

export const SEMANTIC_LABEL_CLASSES = {
  [SEMANTIC_COLOR.NEUTRAL]:
    'bg-n-label-color outline-n-label-border text-n-slate-12',
  [SEMANTIC_COLOR.INFO]: 'bg-n-iris-2 outline-n-iris-4 text-n-iris-12',
  [SEMANTIC_COLOR.SUCCESS]: 'bg-n-teal-2 outline-n-teal-4 text-n-teal-12',
  [SEMANTIC_COLOR.WARNING]: 'bg-n-amber-2 outline-n-amber-4 text-n-amber-12',
  [SEMANTIC_COLOR.DANGER]: 'bg-n-ruby-2 outline-n-ruby-4 text-n-ruby-12',
};
